var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.008,
    height: 9.873,
    viewBox: "0 0 13.008 9.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M12.158-10.43a.274.274,0,0,1,.469,0l.352.322a.323.323,0,0,1,0,.5L4.189-.82a.3.3,0,0,1-.5,0L.205-4.307a.323.323,0,0,1,0-.5l.352-.322a.278.278,0,0,1,.234-.117.278.278,0,0,1,.234.117l2.9,2.9Z",
    transform: "translate(-0.088 10.562)",
    fill: "#7f7f7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0bbb171cc29fa50a572366b6a69b5c93.svg";
export { ForwardRef as ReactComponent };